import classNames from 'classnames';
import { FlexContainer, Txt } from 'components';
import styles from './AwaitingSignatures.module.scss';

/**
 * AwaitingSignatures
 *
 * @return {JSX.Element}
 */
const AwaitingSignatures = ({ className }) => {
  return (
    <FlexContainer
      className={classNames(
        styles.AwaitingSignatures,
        className,
        AwaitingSignatures.displayName
      )}
      column
      gap
    >
      <Txt bold>Agreement sent 🎉</Txt>
      <Txt regular>
        The agreement has been sent to all parties in the tenancy group for
        review and digital signature. Once signed this agreement will be
        executed as a deed.
      </Txt>
      <Txt regular>
        We automatically send an email reminder 2 days after its created and so
        on until the agreement is signed.
      </Txt>
      <Txt regular>
        Propa will let you know via email and a notification when the agreement
        has been signed by all the relevant parties.
      </Txt>
    </FlexContainer>
  );
};

AwaitingSignatures.displayName = 'AwaitingSignatures';

export default AwaitingSignatures;
